import { Component, Injector } from '@angular/core';
import { BaseFilterComponent } from 'app/core/filter-system';

@Component({
  selector: 'app-sidebar-filters',
  templateUrl: './sidebar-filters.component.html',
  styleUrls: ['./sidebar-filters.component.scss']
})
export class SidebarFiltersComponent extends BaseFilterComponent<number[]> {
  readonly filterId = 'tax_category';

  taxCategorySelection: { [key: string]: boolean } = {};

  constructor(injector: Injector) {
    super(injector);
  }

  getQueryParamKey(): string {
    return 'tax_category';
  }

  parseQueryParam(rawValue: string): void {
    this.taxCategorySelection = {};
    let taxCategory = rawValue.split(',').filter(v => v !== '');

    // Special logic: If 2 is selected, ensure 4 is also selected
    if (taxCategory.includes('2')) {
      if (!taxCategory.includes('4')) {
        taxCategory.push('4');
      }
    }

    taxCategory.forEach(v => {
      this.taxCategorySelection[v] = true;
    });
  }

  buildFilterValue(): number[] {
    const result: number[] = [];
    // Special logic: If 2 is selected, ensure 4 is also selected
    if (this.taxCategorySelection['2']) {
      this.taxCategorySelection['4'] = true;
    }
    for (const key in this.taxCategorySelection) {
      if (this.taxCategorySelection[key]) {
        result.push(+key);
      }
    }
    return result;
  }

  clearSelection(): void {
    this.taxCategorySelection = {};
  }

  checkCategory(): void {
    // If 2 is selected, ensure 4 is also selected
    if (this.taxCategorySelection['2']) {
      this.taxCategorySelection['4'] = true;
    } else {
      // If 2 is unselected, also unselect 4
      delete this.taxCategorySelection['4'];
    }
    this.onFilterChange();
  }
}
